import { useState } from "react";
import InputField from "../components/atoms/InputField";
import ActionButton from "../components/atoms/ActionButton";
import { getCurrentUser, getCurrentPerson, setCurrentPerson } from "../services/authService";

/**
 * AccountPage - アカウント管理画面
 * @param {function} onLogout - ログアウト時のコールバック (App.js から渡される)
 */
function AccountPage({ onLogout }) {
  const user = getCurrentUser();
  const [person, setPerson] = useState(getCurrentPerson);

  const handlePersonChange = (e) => {
    const name = e.target.value;
    setPerson(name);
    setCurrentPerson(name);
  };

  return (
    <div className="p-6 max-w-sm">
      <h2 className="text-base font-medium text-gray-700 mb-4">アカウント情報</h2>

      <table className="border-collapse text-base w-full mb-6">
        <tbody>
          <tr>
            <th className="border border-gray-300 px-4 py-2 text-left font-normal whitespace-nowrap bg-gray-50 w-28">
              店舗名
            </th>
            <td className="border border-gray-300 px-4 py-2">
              {user?.shopName ?? "—"}
            </td>
          </tr>
          <tr>
            <th className="border border-gray-300 px-4 py-2 text-left font-normal whitespace-nowrap bg-gray-50">
              店舗番号
            </th>
            <td className="border border-gray-300 px-4 py-2">
              {user?.shopNo ?? "—"}
            </td>
          </tr>
          <tr>
            <th className="border border-gray-300 px-4 py-2 text-left font-normal whitespace-nowrap bg-gray-50">
              レジ番号
            </th>
            <td className="border border-gray-300 px-4 py-2">
              {user?.regiNo ?? "—"}
            </td>
          </tr>
          <tr>
            <th className="border border-gray-300 px-4 py-2 text-left font-normal whitespace-nowrap bg-gray-50">
              部門名
            </th>
            <td className="border border-gray-300 px-4 py-2">
              {user?.regiName ?? "—"}
            </td>
          </tr>
        </tbody>
      </table>

      {/* 担当者名の編集 */}
      <div className="mb-6">
        <h3 className="text-base font-medium text-gray-700 mb-2">担当者名</h3>
        <p className="text-base text-gray-500 mb-2">
          このセッション中の担当者名を変更できます。ログアウトすると初期値に戻ります。
        </p>
        <InputField
          value={person}
          onChange={handlePersonChange}
          numericOnly={false}
          textAlignClass="text-left"
          widthClass="w-full"
          sizeClass="px-3 py-2 text-base"
          borderClass="border border-gray-300 rounded focus:outline-none focus:border-blue-400"
        />
      </div>

      <ActionButton label="ログアウト" onClick={onLogout} paddingClass="px-6 py-2" textSizeClass="text-base" />
    </div>
  );
}

export default AccountPage;
